/**
 * This object serves to aggregate event handling functions.
 * The executeEvents() function can be registered as an event
 * handler, and it will call all the aggregated handler functions
 * that are in the events list.
 *
 * The eventScope can be set to an object needed to be applied as the
 * "this" object when the aggregated functions execute.  If it is
 * not set, the aggregated functions execute in the context of the
 * window object.
 */

'use strict';

var EventsHandler = function() {
    this.initialize();
};

EventsHandler.prototype = {
    events: null,
    eventScope: null,
    stopExecution: null,
    bubbleExceptions: false,

    /*
        Public Getters / Setters
    */
    setEventScope: function(scope){
        this.eventScope = scope;
    },

    getEvents: function(){
        return this.events;
    },

    /*
        Public Methods
    */
    initialize: function(){
        this.events = new Array();
    },

    addEvent: function(func){
        this.events[this.events.length] = func;
    },

    removeEvent: function(func){
        for(var i = 0; i < this.events.length; i++){
            if(this.events[i] === func){
                this.events[i] = null;
            }
        }
    },

    skipNextExecution: function() {
        this.stopExecution = true;
    },

    executeEvents: function(){
        if(this.stopExecution){
            this.stopExecution = false;
            return;
        }
        for(var i = 0; i < this.events.length; i++){
            try {
                if(this.events[i] != null){
                    if(this.eventScope != null){
                        this.events[i].apply(this.eventScope, arguments);
                    } else {
                        this.events[i].apply(window, arguments);
                    }
                }
            } catch (ex) {
                if(this.bubbleExceptions) {
                    throw ex;
                }
                console.error('Error executing event in MITS.Events.EventHandler', ex);
            }
        }
    },

    clearEvents: function() {
        for(var i = 0; i < this.events.length; i++){
            delete(this.events[i]);
            this.events[i] = null;
        }
    },

    setBubbleExceptions: function(bubble) {
        this.bubbleExceptions = bubble;
    },

    toString: function(){
        var eventsStrings = '';
        for(var i = 0; i < this.events.length; i++){
            eventsStrings += '\n\n[Index: ' + i + ']\n' + this.events[i];
        }
        return '[MITS.Events.EventsHandler]' + eventsStrings;
    }
};

module.exports = EventsHandler;


//////////////////
// WEBPACK FOOTER
// ./mits/Events/EventsHandler.js
// module id = 1
// module chunks = 0